import Header, { Menu, PrimaryLink } from 'component/base/Header';
import { HrefLink } from 'component/base/Link';
import { Logo } from 'component/base/Logo';
import React from 'react';

import { ActivateLink, Container, Footer } from './styles';

interface IAuthLayout {
  children: React.ReactNode;
  showActivateInviteCodeLink?: boolean;
  showSignUpButton?: boolean;
}

const AuthLayout = ({
  children,
  showActivateInviteCodeLink = true,
  showSignUpButton = true,
}: IAuthLayout) => (
  <Container>
    <Header fixed>
      <Logo />
      {showSignUpButton && (
        <Menu>
          Don&apos;t have an account?
          <PrimaryLink to="/signup">Sign up</PrimaryLink>
        </Menu>
      )}
    </Header>

    {children}
    {showActivateInviteCodeLink && (
      <ActivateLink to="/onboarding/register" active>
        Activate my invite code
      </ActivateLink>
    )}
    <Footer>
      <p>
        If you have any questions please email
        <HrefLink href="mailto:help@beecastle.com">help@beecastle.com</HrefLink>
      </p>
      <p>
        <HrefLink
          href="https://beecastle.com/terms"
          style={{ textDecoration: 'underline' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </HrefLink>

        <HrefLink
          href="https://beecastle.com/privacy"
          style={{ textDecoration: 'underline' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </HrefLink>
      </p>
    </Footer>
  </Container>
);

export default AuthLayout;
